var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-84c0435e-9966-490c-890e-6f452ae2a453",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#9E9E9E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,4.8c0-1.32,1.08-2.4,2.4-2.4H21.6c.64,0,1.25,.25,1.7,.7,.45,.45,.7,1.06,.7,1.7v14.4c0,.64-.25,1.25-.7,1.7-.45,.45-1.06,.7-1.7,.7H2.4c-.64,0-1.25-.25-1.7-.7-.45-.45-.7-1.06-.7-1.7V4.8ZM13.2,15.6l-3.6-3.6-7.2,7.2H21.6l-6-6-2.4,2.4Zm4.8-4.8c.64,0,1.25-.25,1.7-.7,.45-.45,.7-1.06,.7-1.7s-.25-1.25-.7-1.7c-.45-.45-1.06-.7-1.7-.7s-1.25,.25-1.7,.7c-.45,.45-.7,1.06-.7,1.7s.25,1.25,.7,1.7,1.06,.7,1.7,.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.19b98eabeb08cb74dfae3415fecb5e25.svg";
export { ForwardRef as ReactComponent };